module.exports = [{
      plugin: require('../.yarn/__virtual__/gatsby-plugin-manifest-virtual-356a8e755b/3/buildhome/.yarn/berry/cache/gatsby-plugin-manifest-npm-5.15.0-b7ab76857b-10c0.zip/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Alexandra Jacob Yoga","short_name":"Alexandra Jacob","start_url":"/","background_color":"#ffffff","theme_color":"#b3b3b3","icon":"src/img/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"3fc5b51e90db18a0e8004143cf2f555a"},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../.yarn/unplugged/gatsby-virtual-9560519c54/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
